<template>
  <div>
    <select v-model="operation.name"
            v-if="!readonly"
            @change="focus(0)"
    >
      <option value=""></option>
      <option value=addTasks>{{ i18n.addTasks }}</option>
      <option value=completeTasks>{{ i18n.completeTasks }}</option>
      <option value=assignTasks>{{ i18n.assignTasks }}</option>
    </select>

    <br/>
    <div v-if="operation.name">
      <div
        v-for="(task, idx) in operation.tasks"
        :key="task.id"
        class="tasks-item"
        ref=tasks
        >
          <i class="clickable icon-minus-sign text-red"
             v-if="!readonly"
             @click.stop="remove(idx)"></i>
          <div style="display: inline-block">
            <input type=text v-model="task.name">
            <UsermTypeaheadVue v-if='["addTasks","assignTasks"].includes(operation.name)'
                  :usermBaseUrl="usermBaseUrl"
                  v-model="task.assignee"
                  :i18n="i18n"
            >
            </UsermTypeaheadVue>
          </div>
      </div>
       <i class="clickable icon-plus-sign text-green"
          v-if="!readonly && operation.name"
          @click="add"></i>
    </div>
  </div>
</template>

<script>
import UsermTypeaheadVue from "./userm-typeahead.vue";

var fakeIds = 0;

export default {
  components: {
    UsermTypeaheadVue
  },

  model: {
    prop: 'operation',
    event: 'change'
  },

  props: {
    operation: Object,
    readonly: Boolean,
    usermBaseUrl:String,
    i18n: Object
  },

  methods: {
    focus: function(idx){
      this.$nextTick(() => {
        if (this.$refs.tasks[idx]) {
            this.$refs.tasks[idx].querySelector("input[type=text]").focus()
        }
      })
    },

    add: function(){
      this.operation.tasks.push({id: ++fakeIds, name: '', editing: true});
      this.focus(this.operation.tasks.length - 1)
    },

    remove: function(idx){
      this.operation.tasks.splice(idx, 1);
    }
  }
}
</script>

<style>
</style>

<!-- vim: set sw=2 ts=2 et : -->
